import { makeStyles, shorthands, typographyStyles } from '@fluentui/react-components';

export const useCommonComponentsStyles = makeStyles({
  title: {
    ...typographyStyles.subtitle2,
    ...shorthands.margin('0'),
  },
  spacer: {
    flexGrow: 1,
  },
});
